import 'css-chunksrc/client/scenes/wbs/task/styles.scss';export default {
  "task": "_task_a1mmf_1",
  "contextualMenu": "_contextualMenu_a1mmf_7",
  "taskDetails": "_taskDetails_a1mmf_11",
  "name": "_name_a1mmf_18",
  "icon": "_icon_a1mmf_34",
  "taskAdvancement": "_taskAdvancement_a1mmf_38",
  "allocations": "_allocations_a1mmf_44",
  "text": "_text_a1mmf_51",
  "completionDate": "_completionDate_a1mmf_57",
  "tick": "_tick_a1mmf_63",
  "late": "_late_a1mmf_70",
  "displayedContextualMenu": "_displayedContextualMenu_a1mmf_79",
  "taskStatus": "_taskStatus_a1mmf_87",
  "placeholder": "_placeholder_a1mmf_93",
  "row": "_row_a1mmf_98",
  "comments": "_comments_a1mmf_104",
  "constrained": "_constrained_a1mmf_108",
  "allocated": "_allocated_a1mmf_112",
  "constraintsPopup": "_constraintsPopup_a1mmf_117"
};